// DS7.5M
import React from 'react';
import c from 'classnames';
import s from './PromoBannerMobile.scss';

interface Props {
  className?: string;
  variant: 'subscriptions' | 'adoptables';
  message: React.ReactNode;
}

const PromoBannerMobile: React.FC<Props> = ({
  className,
  variant,
  message,
}) => {
  return (
    <div className={c(s['root'], s[`variant-${variant}`], className)}>
      {message}
    </div>
  );
};
PromoBannerMobile.displayName = 'PromoBannerMobile';

export default PromoBannerMobile;
